<template>
  <div class="link-settings-wrap">
    <b-form-radio-group
      v-model="firstOptionPosition"
      :options="linkSettingList"
      value-field="value"
      text-field="label"
      :buttons="true"
      :disabled="element.settings.disabled || !isUserHasAccess"
      @change="handleSizeChange"
    ></b-form-radio-group>
  </div>
</template>

<script>
export default {
  name: 'OptionSizeSettings',
  data() {
    return {
      linkSettingList: [
        { label: 'Links', value: 'left' },
        { label: 'Mittle', value: 'center' },
        { label: 'Rechts', value: 'right' },
      ],
    };
  },
  props: {
    syncPosition: { type: Boolean, default: false },
    option: { type: Object, default: null },
    element: Object,
    isUserHasAccess: Boolean,
  },
  created() {
    this.ensureOptionLinkDetails(this.option);
    if (this.syncPosition) this.syncAllOptionPositions();
  },
  methods: {
    handleSizeChange() {
      if (this.syncPosition) this.syncAllOptionPositions();
    },
    ensureOptionLinkDetails(option) {
      if (!option) return;
      if (!option.linkDetails) {
        this.$set(option, 'linkDetails', {
          label: 'Link',
          link: '',
          position: 'left',
        });
      } else if (!option.linkDetails.position) {
        this.$set(option.linkDetails, 'position', 'left');
      }
    },
    syncAllOptionPositions() {
      if (!Array.isArray(this.element?.options)) return;
      const position = this.firstOptionPosition || 'left';
      this.element.options.forEach((option) => {
        this.ensureOptionLinkDetails(option);
        this.$set(option.linkDetails, 'position', position);
      });
    },
  },
  computed: {
    firstOptionPosition: {
      get() {
        return this.element?.options?.[0]?.linkDetails?.position || 'left';
      },
      set(value) {
        if (
          !Array.isArray(this.element?.options) ||
          !this.element.options.length
        )
          return;
        this.element.options.forEach((option) => {
          this.ensureOptionLinkDetails(option);
          this.$set(option.linkDetails, 'position', value);
        });
      },
    },
  },
};
</script>

<style scoped>
.link-settings-wrap {
  padding: 12px 0;
  padding-left: 20px;
  width: 100%;
}
.link-settings-wrap ::v-deep .btn-group-toggle {
  display: flex;
  gap: 7px;
  align-items: center;
  justify-content: start;
  flex-flow: row;
}
.link-settings-wrap ::v-deep .btn {
  border-radius: 16px !important;
  height: 30px;
  width: 61px;
  max-width: 61px;
  border: 0.7px solid #d9dbdc;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  font-family: 'OpenSans-regular';
  font-size: 14px;
  letter-spacing: -0.02em;
  line-height: 30px;
  color: #000000;
  transition: transform 0.3s ease;
}
.link-settings-wrap ::v-deep .btn:hover {
  border-color: #000000;
  transition: 0.2s ease all;
}
.link-settings-wrap ::v-deep .btn.active {
  background-color: #060606;
  border-color: #060606;
  color: #ffffff;
}

.link-settings-wrap ::v-deep .btn input {
  display: none;
}
</style>
